import { types } from 'mobx-state-tree';

const Image = types.model({
  path: types.string,
});

export default Image;
